const cleanData = (values) => {
  let filterArray = ["_", "__typename"];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  if (!values["files"]) {
    values["files"] = [];
  }

  if (
    values["b14_emp_type_id"] &&
    values["b14_emp_type_id"] === "Job Contractor - Joint Employer"
  ) {
    data["b15_appx_a_attached"] = "YES";
    data["b16_contract_file"] = "YES";
  } else {
    data["b15_appx_a_attached"] = "NO";
    data["b16_contract_file"] = "NO";
  }

  // Clean file objects
  if (
    values["a6_emergency_justification"] &&
    typeof values["a6_emergency_justification"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["a6_emergency_justification"]
    );
    values["a6_emergency_justification"] =
      values["a6_emergency_justification"][0]["fileType"];
    values["a6_emergency_attached"] = "YES";
  }
  if (
    values["b16_contract_attached"] &&
    typeof values["b16_contract_attached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["b16_contract_attached"]);
    values["b16_contract_attached"] =
      values["b16_contract_attached"][0]["fileType"];
    values["b16_contract_file"] = "YES";
  }
  if (
    values["d20_agent_agreement_attached"] &&
    typeof values["d20_agent_agreement_attached"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["d20_agent_agreement_attached"]
    );
    values["d20_agent_agreement_attached"] =
      values["d20_agent_agreement_attached"][0]["fileType"];
    values["d20_agent_agreement_attached_attached"] = "YES";
  }
  if (
    values["ef_1_assurance_attached"] &&
    typeof values["ef_1_assurance_attached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["ef_1_assurance_attached"]);
    values["ef_1_assurance_attached"] =
      values["ef_1_assurance_attached"][0]["fileType"];
    values["ef_1_assurance"] = "YES";
  }
  if (
    values["ef_2_assurance_attached"] &&
    typeof values["ef_2_assurance_attached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["ef_2_assurance_attached"]);
    values["ef_2_assurance_attached"] =
      values["ef_2_assurance_attached"][0]["fileType"];
    values["ef_2_assurance"] = "YES";
  }

  // Clean file fields
  if (values["files"]) {
    values["files"].filter(
      (file) => file.machine_name === "a6_emergency_justification"
    ).length > 0
      ? (data["a6_emergency_attached"] = "YES")
      : (data["a6_emergency_attached"] = "NO");

    values["files"].filter(
      (file) => file.machine_name === "b16_contract_attached"
    ).length > 0
      ? (data["b16_contract_file"] = "YES")
      : (data["b16_contract_file"] = "NO");

    values["files"].filter(
      (file) => file.machine_name === "d20_agent_agreement_attached"
    ).length > 0
      ? (data["d20_agent_agreement_attached_attached"] = "YES")
      : (data["d20_agent_agreement_attached_attached"] = "NO");

    values["files"].filter(
      (file) => file.machine_name === "ef_1_assurance_attached"
    ).length > 0
      ? (data["ef_1_assurance"] = "YES")
      : (data["ef_1_assurance"] = "NO");

    values["files"].filter(
      (file) => file.machine_name === "ef_2_assurance_attached"
    ).length > 0
      ? (data["ef_2_assurance"] = "YES")
      : (data["ef_2_assurance"] = "NO");

    if (values["files"].length > 0) {
      for (let j = 0; j < values["files"].length; j++) {
        data["files"][j].size = data["files"][j].size.toString();
        delete data["files"][j].fileTypes;
        data["files"][j].lastModified =
          data["files"][j].lastModified.toString();
        delete data["files"][j].fileUploadedFrom;
        if (data["files"][j].__typename) {
          delete data["files"][j].__typename;
        }
      }
    }
  }
  return data;
};

export { cleanData };
